
/* ---------------------------------------------------------------
   TOKENS — "JoTrade Pro" dark-navy palette. Two accent families,
   kept under their original key names (`green*` / `violet*`) so the
   hundred-odd call sites across the app didn't need touching, but
   the actual hues are now:
   Roles:
   - bg canvas:          #030407
   - bg panel (1):       #0b0d13
   - bg panel (2):       #10131b
   - bg deep accent:     #0a1220
   - border/hairline:    #1b2029
   - sage mid (green*):        #3f6fd6
   - sage bright (greenBright): #5b8cff  — primary brand accent (CTAs, active states, up-candles)
   - sage light (greenLight):   #8fb0ff
   - olive (unused):     #b98a46
   - gold mid (violet):        #c99a52
   - gold bright (violetBright): #e3b873 — secondary/VIP accent
   - gold deep panel (violetDeep): #241c0e
   - text muted a:       #3d4250
   - text muted b:       #565d6e
   - text secondary:     #8b93a5
   - text primary:       #eef1ec
------------------------------------------------------------------ */

export const C = {
  canvas: "#030407",
  panel1: "#0b0d13",
  panel2: "#10131b",
  deep: "#0a1220",
  hairline: "#1b2029",
  green: "#3f6fd6",
  greenBright: "#5b8cff",
  greenLight: "#8fb0ff",
  olive: "#b98a46",
  violet: "#c99a52",
  violetBright: "#e3b873",
  violetDeep: "#241c0e",
  mutedA: "#3d4250",
  mutedB: "#565d6e",
  secondary: "#8b93a5",
  primary: "#eef1ec",

  // Per-section accents — Profile/Signals keep the sage/gold pair
  // above; these four give Scanner, Live Charts, Education and
  // Copytrading their own identity (card shape lives in each
  // section's own components, these are just the hues) so the four
  // sections read as distinct rather than reskins of one template.
  scan: "#1f8f82",
  scanBright: "#3ddbc4",
  scanDeep: "#0e2e2b",
  live: "#6d5bd0",
  liveBright: "#9b8afb",
  liveDeep: "#211c3d",
  edu: "#d97a3d",
  eduBright: "#ffab6b",
  eduDeep: "#3a2210",
  copy: "#1fa463",
  copyBright: "#4ade80",
  copyDeep: "#0f2e1d",
};

// Aliases matching the reference design's own naming ("sage" = primary
// brand blue, "gold" = VIP/secondary accent) — same values as above,
// for any new code that wants to read intent-first instead of legacy names.
export const SAGE = C.greenBright;
export const SAGE_DIM = "rgba(91,140,255,.13)";
export const SAGE_GLOW = "rgba(91,140,255,.28)";
export const GOLD = C.violetBright;
export const GOLD_DIM = "rgba(227,184,115,.15)";
export const GOLD_GLOW = "rgba(227,184,115,.3)";

// Single functional down-candle / loss color, not part of the brand
// palette — reused by Live Charts, the active-signal overlay and the
// profile's signal history, so it lives here instead of being
// redefined in each screen.
export const RED = "#C4604A";

// Structural breakpoint: below it the app is a single column with a
// bottom tab bar (phones/narrow tablets); at/above it a persistent
// left rail replaces the bottom bar. See hooks/useBreakpoint.js.
export const WIDE_BREAKPOINT = 880;

export const labelStyle = {
  fontSize: 12,
  color: C.mutedB,
  marginBottom: 8,
  fontFamily: "'Space Grotesk', sans-serif",
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: "0.06em",
};

export const fonts = {
  display: "'Space Grotesk', sans-serif",
  body: "'Inter', sans-serif",
  mono: "'JetBrains Mono', monospace",
};